import React from "react";
import { Users, Send } from "lucide-react";
import { Card, BtnPrimary } from "./ui";

export default function CustomerCareCard({ care_team, accent, t, onMessage }) {
  const team = Array.isArray(care_team)
    ? care_team.filter(member => typeof member?.name === "string" && member.name.trim()) : [];
  return (
    <Card className="p-5 flex flex-col" data-testid="ov-care-team">
      <div className="flex items-center gap-2 mb-4">
        <Users className="w-5 h-5" style={{ color: accent }} />
        <h2 className="font-bold">{t(team.length === 1 ? "Ihre Ansprechperson" : "Ihr KEWAG-Betreuungsteam")}</h2>
      </div>
      {team.length > 0 ? <ul className="space-y-3 mb-4" data-testid="ov-care-avatars">
        {team.map((member, i) => <li key={i} className="flex items-center gap-3" data-testid={`ov-care-member-${i}`}>
          {member.picture
            ? <img src={member.picture} alt="" className="w-11 h-11 rounded-full object-cover shrink-0" />
            : <span aria-hidden="true" className="w-11 h-11 rounded-full flex items-center justify-center text-sm font-bold shrink-0"
                style={{ background: `${accent}22`, color: accent }}>{member.name.trim().split(/\s+/).map(p => p[0]).slice(0, 2).join("")}</span>}
          <span className="font-semibold text-gray-100 break-words min-w-0">{member.name}</span>
        </li>)}
      </ul> : <>
        <p className="text-lg font-bold mb-2">KEWAG Support</p>
        <p className="text-sm text-gray-400 mb-4">{t("Eine persönliche Ansprechperson ist noch nicht zugewiesen. Unser Support hilft Ihnen weiter.")}</p>
      </>}
      <p className="text-sm text-gray-400 flex-1">{t("Ihre Fragen und Wünsche bleiben hier bei Ihrem Kundenkonto.")}</p>
      <BtnPrimary accent={accent} className="w-full mt-4 min-h-[44px]" data-testid="ov-message" onClick={onMessage}>
        <Send className="w-4 h-4" /> {t("Nachricht senden")}
      </BtnPrimary>
      <a href="mailto:support@kewagpage.ch" data-testid="ov-mail-fallback" className="block text-center text-xs text-gray-400 hover:text-gray-200 mt-3 py-2">{t("KEWAG Support per E-Mail kontaktieren")}</a>
    </Card>
  );
}
